
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function NonUnionOfBone(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Non union of bone"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Nonunion of bone is the <b>the body's inability to heal a fracture.</b> The
                                    most agreed-upon standard definition of nonunion made by the
                                    FDA is a fracture that persists for a minimum of nine months without
                                    signs of healing for three months.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Non-union-of-bone/1.png")} alt="Non-union-of-bone" />
                                    </div>
                                </div>
                                <br></br>

                                <a className="links" href="https://en.wikipedia.org/wiki/Nonunion">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default NonUnionOfBone;